import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, TextField, Switch, FormControlLabel, Chip, Divider, Typography } from '@mui/material';
import { DateRange, Edit } from '@mui/icons-material';
import dayjs from 'dayjs';

const TaskScheduleBadge = ({ startDate, startTime, endDate, endTime, callBack }) => {
    const [dialogStatus, setDialogStatus] = useState(false);
    
    // State for all 4 schedule points
    const [inStartDate, setInStartDate] = useState(startDate || "");
    const [inStartTime, setInStartTime] = useState(startTime || "09:00");
    const [inEndDate, setInEndDate] = useState(endDate || "");
    const [inEndTime, setInEndTime] = useState(endTime || "18:00");
    
    const [notify, setNotify] = useState(false);
    const [remark, setRemark] = useState("");

    const handleUpdate = () => {
        if (callBack) {
            callBack({
                startDate: inStartDate,
                startTime: inStartTime,
                endDate: inEndDate,
                endTime: inEndTime,
                notify: notify,
                remark: remark
            });
        }
        setDialogStatus(false);
        setRemark("");
    };

    // Formatted Display for the Chip
    const formatDT = (d, t) => d ? `${dayjs(d).format('MMM DD')} ${dayjs(`2000-01-01 ${t}`).format('hh:mm A')}` : '...';
    const chipLabel = `${formatDT(startDate, startTime)} — ${formatDT(endDate, endTime)}`;
    //const chipLabel = callBack ? `${formatDT(startDate, startTime)} — ${formatDT(endDate, endTime)}` :`${formatDT(endDate, endTime)}`;
    
    // Overdue Logic
    const isOverdue = endDate && dayjs(`${endDate} ${endTime}`).isBefore(dayjs());

    return (
        <>
            {callBack ?
                <Chip 
                    icon={<DateRange style={{ fontSize: '16px', color: 'inherit' }} />}
                    label={chipLabel}
                    onClick={callBack ? () => setDialogStatus(true) : undefined}
                    onDelete={callBack ? () => setDialogStatus(true) : undefined}
                    deleteIcon={callBack ? <Edit style={{ fontSize: '14px' }} /> : null}
                    variant="outlined"
                    className={isOverdue ? "border-danger text-danger" : "bg-white"}
                    sx={{ 
                        fontWeight: 'bold',
                        cursor: callBack ? 'pointer' : 'default',
                        height: 'auto',
                        py: 0.5,
                        '& .MuiChip-label': { px: 1, whiteSpace: 'normal' }
                    }} 
                />
                : <span className={isOverdue ? " blink-infinite border-danger text-danger" : "bg-white"}>{formatDT(endDate, endTime)}</span>
            }

            {callBack && (
                <Dialog
                    open={dialogStatus}
                    onClose={() => setDialogStatus(false)}
                    fullWidth={true}
                    maxWidth="sm" // Slightly wider to fit two columns
                >
                    <div className='p-3 fw-bold border-bottom'>Update Task Schedule</div>
                    <DialogContent>
                        <div className='row mt-2'>
                            {/* START SCHEDULE */}
                            <div className='col-md-12 mb-2'>
                                <Typography variant="caption" color="primary" className="fw-bold">START SCHEDULE</Typography>
                            </div>
                            <div className='col-md-7'>
                                <TextField fullWidth label="Start Date" type="date" value={inStartDate} 
                                    onChange={(e) => setInStartDate(e.target.value)} margin="dense" InputLabelProps={{ shrink: true }} />
                            </div>
                            <div className='col-md-5'>
                                <TextField fullWidth label="Start Time" type="time" value={inStartTime} 
                                    onChange={(e) => setInStartTime(e.target.value)} margin="dense" InputLabelProps={{ shrink: true }} />
                            </div>

                            <div className='col-md-12 my-2'>
                                <Divider />
                            </div>

                            {/* END SCHEDULE */}
                            <div className='col-md-12 mb-2'>
                                <Typography variant="caption" color="error" className="fw-bold">END SCHEDULE (DEADLINE)</Typography>
                            </div>
                            <div className='col-md-7'>
                                <TextField fullWidth label="End Date" type="date" value={inEndDate} 
                                    onChange={(e) => setInEndDate(e.target.value)} margin="dense" InputLabelProps={{ shrink: true }} />
                            </div>
                            <div className='col-md-5'>
                                <TextField fullWidth label="End Time" type="time" value={inEndTime} 
                                    onChange={(e) => setInEndTime(e.target.value)} margin="dense" InputLabelProps={{ shrink: true }} />
                            </div>

                            <div className='col-md-12 mt-3'>
                                <TextField fullWidth multiline rows={2} label="Remark" value={remark}
                                    onChange={(e) => setRemark(e.target.value)} margin="normal" placeholder="Reason for rescheduling..." />
                                
                                <FormControlLabel
                                    control={<Switch checked={notify} onChange={(e) => setNotify(e.target.checked)} />}
                                    label="Send updated Calendar Invite to all attendees"
                                />
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions className="p-3">
                        <button className='btn btn-light' onClick={() => setDialogStatus(false)}>Cancel</button>
                        <button className='btn btn-primary' onClick={handleUpdate}>Update Timeline</button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );
};

export default TaskScheduleBadge;